// components/ui/Card.jsx
import React, { useState } from 'react';

export function Card({ children, hover, onClick, style = {} }) {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => hover && setIsHovered(true)}
      onMouseLeave={() => hover && setIsHovered(false)}
      style={{
        background: '#FFFFFF',
        borderRadius: 12,
        padding: 24,
        boxShadow: isHovered 
          ? '0 8px 24px rgba(0,0,0,0.12)' 
          : '0 1px 3px rgba(0,0,0,0.1)',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.2s',
        transform: isHovered ? 'translateY(-2px)' : 'translateY(0)',
        border: '1px solid #F3F4F6',
        ...style
      }}
    >
      {children}
    </div>
  );
}